import {
  type MainDateTimePickerAlias,
  type DateTimeFilter,
  getDateTimeFilterByAlias,
} from '~/presentation/ui';

import { createPersistedStoreWithShopId } from '~/utils/createPersistedStore';
import { EAnalyticMode } from '~/modules/analytics/types';
import { dayjsTzToLocalTZ } from '~/utils/dayjs';

export interface IPageAnalyticFilterStoreState {
  analyticMode: EAnalyticMode;
  setAnalyticMode: (analyticMode: EAnalyticMode) => void;
  dateTimePicked?: DateTimeFilter;
  setDateTimePicked: (dateTimePicked: DateTimeFilter) => void;
  getDateTime: () => DateTimeFilter | undefined;
  hasAnalyticsData: boolean;
  setHasAnalyticsData: (hasAnalyticsData: boolean) => void;
}

export const usePageAnalyticFilterStore =
  createPersistedStoreWithShopId<IPageAnalyticFilterStoreState>(
    'page-analytic-filter',
    (set, get) => ({
      analyticMode: EAnalyticMode.ALL_SESSION,
      dateTimePicked: undefined,
      setAnalyticMode: (analyticMode) => set({ analyticMode }),
      setDateTimePicked: (dateTimePicked) => set({ dateTimePicked }),
      getDateTime: () => {
        const dateTimePicked = get().dateTimePicked;
        if (!dateTimePicked) return undefined;

        //case custom date
        const alias = dateTimePicked.alias as MainDateTimePickerAlias;
        const dateConfig = getDateTimeFilterByAlias(alias);
        const currentDate = dayjsTzToLocalTZ().startOf('day');

        if (!dateConfig) return dateTimePicked;

        return {
          ...dateConfig,
          ...dateConfig.getDateRange(currentDate),
        };
      },
      hasAnalyticsData: false,
      setHasAnalyticsData: (value) => {
        //Only set once
        if (get().hasAnalyticsData) return;

        set({ hasAnalyticsData: value });
      },
    }),
  );
